import "core-js/modules/es.number.constructor.js";
export var BASE_COMMENTS_KEY = 'comments';
var commentKeys = {
  comments: [BASE_COMMENTS_KEY],
  singleComment: function singleComment(id) {
    return [BASE_COMMENTS_KEY, 'single', Number(id)];
  },
  contentComments: function contentComments(contentId) {
    return [BASE_COMMENTS_KEY, Number(contentId)];
  },
  contentCommentReplies: function contentCommentReplies(contentId, parentId) {
    return [BASE_COMMENTS_KEY, Number(contentId), 'replies', Number(parentId)];
  }
};
export default commentKeys;